<section class="gen-page">
  <div class="page-shell">
    <a routerLink="/register" class="crumb">Select Stakeholder <span>›</span> Generating Company Registration</a>

    <header class="hero">
      <div class="hero-left">
        <button type="button" class="back-btn" routerLink="/register">←</button>
        <div>
          <h1>Generating Company Registration</h1>
          <p>Power Generation Entity - Fill in all required fields and submit. Your request will be sent to MSLDC Admin for approval.</p>
        </div>
      </div>
      <div class="hero-pill">No login required</div>
    </header>

    <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
      <section class="panel">
        <div class="panel-head">Company Information</div>
        <div class="grid two">
          <label>
            <span>Company Name *</span>
            <input formControlName="company_name" placeholder="e.g. Maharashtra Power Gen Pvt Ltd">
          </label>
          <label>
            <span>Parent Company</span>
            <input formControlName="parent_company" placeholder="Holding Company Name">
          </label>
          <label>
            <span>Registration Type *</span>
            <select formControlName="registration_type">
              <option value="">Select Type</option>
              <option>Solar</option>
              <option>Wind</option>
              <option>Hydro</option>
              <option>Hybrid</option>
            </select>
          </label>
          <label>
            <span>CIN / Registration No. *</span>
            <input formControlName="cin_registration_no" placeholder="e.g. U40102MH2010PTC123456">
          </label>
          <label>
            <span>Installed Capacity (MW) *</span>
            <input formControlName="installed_capacity_mw" placeholder="e.g. 250.00">
          </label>
          <label>
            <span>Energy Source *</span>
            <select formControlName="energy_source">
              <option value="">Select Source</option>
              <option>Solar</option>
              <option>Wind</option>
              <option>Hydro</option>
              <option>Hybrid</option>
            </select>
          </label>
          <label>
            <span>SCADA / Telemetry Available? *</span>
            <select formControlName="scada_telemetry_available">
              <option value="">Select</option>
              <option>Yes</option>
              <option>No</option>
            </select>
          </label>
          <label>
            <span>Commissioning Date *</span>
            <input formControlName="commissioning_date" type="date">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Registered Office Address</div>
        <div class="grid two">
          <label class="span-2">
            <span>Address Line 1 *</span>
            <input formControlName="address_line1" placeholder="Building / Plot No., Street">
          </label>
          <label>
            <span>Address Line 2</span>
            <input formControlName="address_line2" placeholder="Area / Locality">
          </label>
          <label>
            <span>City / Town *</span>
            <input formControlName="city_town" placeholder="e.g. Pune">
          </label>
          <label>
            <span>District *</span>
            <input formControlName="district" placeholder="Select District">
          </label>
          <label>
            <span>State *</span>
            <input formControlName="state" placeholder="Select State">
          </label>
          <label>
            <span>Pin Code *</span>
            <input formControlName="pin_code" placeholder="e.g. 411001">
          </label>
          <label>
            <span>Country *</span>
            <input formControlName="country" placeholder="India">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Nodal Officer Details</div>
        <div class="grid two">
          <label>
            <span>Full Name *</span>
            <input formControlName="contact_person_name" placeholder="Nodal Officer Name">
          </label>
          <label>
            <span>Designation</span>
            <input formControlName="designation" placeholder="e.g. Manager - Grid Operations">
          </label>
          <label>
            <span>Mobile Number *</span>
            <input formControlName="mobile_number" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Email Address *</span>
            <input formControlName="email_address" placeholder="nodal@company.com" type="email">
          </label>
          <label>
            <span>Alternate Mobile</span>
            <input formControlName="alternate_mobile" placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Alternate Email</span>
            <input formControlName="alternate_email" placeholder="alternate@company.com">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Alternate Nodal Officer</div>
        <div class="grid two">
          <label>
            <span>Full Name</span>
            <input placeholder="Nodal Officer Name">
          </label>
          <label>
            <span>Designation</span>
            <input placeholder="e.g. Manager - Grid Operations">
          </label>
          <label>
            <span>Mobile Number</span>
            <input placeholder="+91 98765 43210">
          </label>
          <label>
            <span>Email Address</span>
            <input placeholder="alternate@company.com">
          </label>
        </div>
      </section>

      <section class="panel">
        <div class="panel-head">Document Upload</div>
        <div class="upload-list">
          @for (document of documents; track document) {
            <div class="upload-card">
              <span class="upload-title">{{ document }} *</span>
              <div class="upload-box">
                <div class="upload-icon">⇪</div>
                <p>Drop files here or <strong>browse</strong></p>
                <small>PDF, JPG, PNG up to 10 MB each</small>
              </div>
            </div>
          }
        </div>
      </section>

      <section class="panel declaration-panel">
        <div class="panel-head">Declaration</div>
        <div class="declaration">
          <p>
            I hereby declare that the information furnished above is true and correct to the best of my knowledge and belief.
            I understand that in the event of any information being found false or incorrect, my registration is liable to be
            cancelled without any notice.
          </p>
        </div>
        <label class="terms">
          <input type="checkbox" formControlName="declaration_accept">
          <span>I agree to the <strong>Terms & Conditions</strong> and <strong>Privacy Policy</strong> of the RE-DSM system.</span>
        </label>
      </section>

      @if (message) {
        <p class="message">{{ message }}</p>
      }

      <footer class="footer-actions">
        <div class="note">Fields marked * are mandatory. Your registration request will be sent to the MSLDC Admin for review. No login is required to submit.</div>
        <div class="actions">
          <a routerLink="/register" class="btn ghost">Cancel</a>
          <button type="button" class="btn ghost">Reset</button>
          <button type="submit" class="btn primary">Send Request to Admin</button>
        </div>
      </footer>
    </form>
  </div>
</section>

